export default __webpack_public_path__ + "static/media/pork.bee5b401.svg";